export default function NumUnitsDisplay({
    numUnits,
    wholesaleUnitsPerCase,
    className
}: {
    numUnits: number;
    wholesaleUnitsPerCase: number;
    className?: string;
}) {
    const cases = Math.floor(Number(numUnits / wholesaleUnitsPerCase));
    const remainder = numUnits % wholesaleUnitsPerCase;
    return (
        <div className={`${className} flex flex-wrap gap-x-1`}>
            <div className="whitespace-nowrap">
                {numUnits} {`unit${numUnits > 1 ? "s" : ""}`}
            </div>
            <div>
                {cases >= 1
                    ? ` (${cases} case${cases > 1 ? "s" : ""}${remainder > 0 ? ` + ${remainder} unit${remainder > 1 ? "s" : ""}` : ""})`
                    : ""}
            </div>
        </div>
    );
}
